
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface TacticalInsightsTabProps {
  data: {
    defensiveLineHeight: {
      team1: {
        average: number;
        highest: number;
        lowest: number;
      };
      team2: {
        average: number;
        highest: number;
        lowest: number;
      };
    };
    counterAttacks: {
      team1: number;
      team2: number;
      averageTransitionTime: number;
    };
    aiRecommendations: string[];
  };
}

const TacticalInsightsTab: React.FC<TacticalInsightsTabProps> = ({ data }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Team Tactics</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Defensive Line Height:</span>
              <div className="mt-1 grid grid-cols-2 gap-2 text-sm">
                <div className="space-y-1">
                  <p className="font-medium">Team 1</p>
                  <p>Average: {data.defensiveLineHeight.team1.average}m</p>
                  <p>Highest: {data.defensiveLineHeight.team1.highest}m</p>
                  <p>Lowest: {data.defensiveLineHeight.team1.lowest}m</p>
                </div>
                <div className="space-y-1">
                  <p className="font-medium">Team 2</p>
                  <p>Average: {data.defensiveLineHeight.team2.average}m</p>
                  <p>Highest: {data.defensiveLineHeight.team2.highest}m</p>
                  <p>Lowest: {data.defensiveLineHeight.team2.lowest}m</p>
                </div>
              </div>
            </div>
            <Separator />
            <div>
              <span className="font-medium">Counter Attacks:</span>
              <div className="mt-1 space-y-1 text-sm">
                <p>Team 1: {data.counterAttacks.team1}</p>
                <p>Team 2: {data.counterAttacks.team2}</p>
                <p>Average Transition Time: {data.counterAttacks.averageTransitionTime}s</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">AI Coaching Insights</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Key Recommendations:</span>
              <ul className="mt-2 space-y-2 text-sm">
                {data.aiRecommendations.map((rec, index) => (
                  <li key={index} className="bg-yellow-50 p-2 rounded border-l-2 border-yellow-400">
                    {rec}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TacticalInsightsTab;
